export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8759.7e33a964.jpg";